export default __webpack_public_path__ + "i8n2CdV-loading.svg";